module.exports = __webpack_public_path__ + "img/egp_fiatrail.82649ad.png";